import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { referralClient } from "@core/clients";
import { InviteVariables, Invitation } from "@core/types";

const useCheckWasInvitedMutation = (options?: UseMutationOptions<Invitation | null, Error, InviteVariables>) =>
  useMutation(
    ["invite-check"],
    async (variables) => {
      const data = await referralClient.checkWasInvited(variables);
      return data;
    },
    {
      retry: 2,
      ...options,
    },
  );

export default useCheckWasInvitedMutation;
